var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import PushNotificationsModule from '../modules/PushNotificationsModule';
class NotificationsStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pushNotificationModule", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "notifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "addNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notifications) => {
                this.notifications.push(...notifications);
            }
        });
        Object.defineProperty(this, "removeNotification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationId) => {
                this.notifications = this.notifications.filter((notification) => notification._id !== notificationId);
            }
        });
        Object.defineProperty(this, "removeNotificationsByType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (type) => {
                this.notifications = this.notifications.filter((notification) => notification.type !== type);
            }
        });
        Object.defineProperty(this, "getNotification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationId) => {
                const notification = this.notifications.find((notification) => notification._id === notificationId);
                if (!notification) {
                    return null;
                }
                return notification;
            }
        });
        Object.defineProperty(this, "clearNotifications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.notifications = [];
            }
        });
        Object.defineProperty(this, "markAsRead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notificationId) => {
                const notification = this.notifications.find(n => n._id === notificationId);
                if (notification) {
                    notification.read = true;
                }
            }
        });
        Object.defineProperty(this, "setIsOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isOpen) => {
                this.isOpen = isOpen;
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.pushNotificationModule = new PushNotificationsModule(this);
    }
}
__decorate([
    observable
], NotificationsStore.prototype, "isOpen", void 0);
__decorate([
    observable
], NotificationsStore.prototype, "notifications", void 0);
__decorate([
    action
], NotificationsStore.prototype, "addNotifications", void 0);
__decorate([
    action
], NotificationsStore.prototype, "removeNotification", void 0);
__decorate([
    action
], NotificationsStore.prototype, "removeNotificationsByType", void 0);
__decorate([
    action
], NotificationsStore.prototype, "clearNotifications", void 0);
__decorate([
    action
], NotificationsStore.prototype, "markAsRead", void 0);
__decorate([
    action
], NotificationsStore.prototype, "setIsOpen", void 0);
export default NotificationsStore;
